module.exports = __webpack_public_path__ + "img/mandatory-institutions.1ae4ba0b.png";